import ConfirmCloseInvestmentDetails from "./ConfirmCloseInvestmentDetails";
import Modal from "components/Modal";

export default function ConfirmCloseInvestment({
  open,
  onClose,
  data,
  
}) {
  return (
    <Modal
      maxWidth={"sm"}
      onClose={onClose}
      open={open}
      title="Close Investment"
      dir="ltr"
    >
      <ConfirmCloseInvestmentDetails
        data={data}
        onClose={onClose}
      />
    </Modal>
  );
}
